import { FC, ReactNode } from "react";
import {
  Breakpoint,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { ButtonProps } from "@mui/material/Button/Button";
import { DialogContentProps } from "@mui/material/DialogContent/DialogContent";
import { DialogTitleClosable } from "../dialog-utils/DialogTitleClosable";

interface ConfirmationDialogProps extends DialogContentProps {
  open: boolean;
  title: string;
  dialogContent?: ReactNode;
  ConfirmButtonProps?: LoadingButtonProps;
  CancelButtonProps?: ButtonProps;
  hideCancelButton?: boolean;
  onClose(): void;
  closeIcon?: boolean;
  maxWidth?: Breakpoint;
}

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  open,
  dialogContent,
  title,
  ConfirmButtonProps,
  CancelButtonProps,
  hideCancelButton,
  onClose,
  closeIcon,
  maxWidth = "sm",
  dividers,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      {closeIcon ? (
        <DialogTitleClosable title={title} onClose={onClose} />
      ) : (
        <DialogTitle>{title}</DialogTitle>
      )}

      <DialogContent
        sx={{
          color: "text.secondary",
        }}
        dividers={dividers}
      >
        {dialogContent}
      </DialogContent>
      <DialogActions>
        {!hideCancelButton ? (
          <Button {...CancelButtonProps} color="tertiary">
            {CancelButtonProps?.children ?? "Cancel"}
          </Button>
        ) : null}
        <LoadingButton
          variant="contained"
          color="primary"
          {...ConfirmButtonProps}
        >
          {ConfirmButtonProps?.children || "Confirm"}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
